export const getIntegration = (state, type) => {
  return state.integrations[type]
}

export const getIdentityField = (state, type) => {
  const identityField = getIntegration(state, type).identityField
  return identityField
}
